
import React from "react";
import "./VirasatDefaultHomePage.scss"
import Button from "../../components/Button/Button";

import ImageCarousel from "../../components/ImageCarousel/ImageCarousel";
import { sortByOrderAscending } from "../../helper/helper";
import { useDispatch } from "react-redux";
import { setIsComing } from "../../../../../../../redux/companyDataSlice";

const VirasatDefaultExpPage = ({ components }) => {
    const dispatch = useDispatch()

    const getLeftComponent = (component) => {
        switch (component.ID) {
            case "VirasatDefaultExpPage-since":
                return <div className="since-text-story">- {component?.Props?.text} -</div>

            case "VirasatDefaultExpPage-header":
                return <div className="VirasatDefaultExpPage-container-title">{component?.Props?.header}</div>

            case "VirasatDefaultExpPage-paragraph":
                return component?.Data?.map((text, key) => {
                    return (
                        <div className="VirasatDefaultExpPage-container-text-cont" key={key}>
                            {text.text}
                        </div>
                    )
                })
            case "VirasatDefaultExpPage-button":
                return <div className="VirasatDefaultExpPage-btn-cont">
                    <Button
                        text={component?.Props?.text}
                        onClick={() => {
                            if (component?.Props?.href && component?.Props?.href !== "") {
                                if (component?.Props?.href?.includes("https://")) {
                                    window.open(component?.Props?.href, '_blank')
                                } else {
                                    window.location.href = component?.Props?.href && component?.Props?.href !== "" ? component?.Props?.href : "/"
                                }

                            }
                            else {
                                dispatch(setIsComing(true))
                            }

                        }}
                    />
                </div>
            default:
                return <div />
        }
    }
    const leftContent = (leftComponents) => {
        return (
            <div className="VirasatDefaultExpPage-container-left">
                {sortByOrderAscending(leftComponents).map((component, key) => {
                    return (
                        getLeftComponent(component)
                    )
                })}

            </div>
        )
    }
    const getComponents = (component) => {
        switch (component.ID) {
            case "VirasatDefaultExpPage-left":
                return leftContent(component?.Components)
            case "VirasatDefaultExpPage-icon":
                return <div className="VirasatDefaultExpPage-container-icon">
                    <div className="VirasatDefaultExpPage-container-icon-inner">
                        <img alt="" src={component?.Props?.icon} />
                    </div>

                </div>
            case "VirasatDefaultExpPage-right":
                return <div className="VirasatDefaultExpPage-container-right">
                    <ImageCarousel
                        content={component?.Data}
                        height={window.screen.width < 1200 ? "477px" : "700px"} />
                </div>
            default:
                return <div />
        }

    }
    return (
        <div className="VirasatDefaultExpPage" >
            <div className="VirasatDefaultExpPage-container">
                {sortByOrderAscending(components).map((component, key) => {
                    return (
                        getComponents(component)
                    )
                })}

            </div>
        </div>
    )
}
export default VirasatDefaultExpPage